import React, { lazy, Suspense } from "react";
import Backdrop from "components/common-components/backdrop";

const Default = lazy(() => import("../../../../../layouts/dashboard/default"));
const AllActionTypes = lazy(() => import("../pages/all-action-types"));

export const ActionTypeRouter = [
  {
    path: "/master-management/action-type",
    element: (
      <Suspense fallback={<Backdrop />}>
        <Default />
      </Suspense>
    ),
    children: [
      {
        path: "all",
        element: (
          <Suspense fallback={<Backdrop />}>
            <AllActionTypes />
          </Suspense>
        ),
      },
    ],
  },
];
